import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import Cookies from 'js-cookie';

class CookieService {
    // Sets cookie for 3000 days
    setPermanentCookie(cookieName, cookieValue) {
        Cookies.set(cookieName, cookieValue, {
            expires: 3000,
            path: '/',
        });
    }
    setCookie(cookieName, cookieValue, lengthInDays, path = '/', domain = '', secure = true) {
        const options = {
            expires: lengthInDays,
            path,
            domain,
            secure,
        };
        Cookies.set(cookieName, cookieValue, options);
    }
    getCookie(cookieName) {
        return Cookies.get(cookieName);
    }
    removeCookie(cookieName) {
        Cookies.remove(cookieName);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: CookieService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: CookieService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: CookieService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CookieService };
